define([
	"dojo/_base/declare",
	"csi/heading/AttributeAction",
	"csi/xml"
], function(declare, AttributeAction, xml) {

	return declare(AttributeAction, {
		bKeepViewEnabled: true,

		constructor: function(def) {
			this.m_id = this.m_id || "FileBrowse";
			this.classController = "csi.heading.FileBrowseController";
			this.m_right = xml.RIGHT_WRITE;
		},

		canBeInlined: function() {
			// summary: action should always be in tooltip
			return false;
		}
	});
});